"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EU_STRATEGIST_TEMPLATES = exports.EU_STRATEGIST_TEMPLATES_MD = void 0;
exports.EU_STRATEGIST_TEMPLATES_MD = {
    'Year Start Meeting (YSM)': `* Three Key Goals for the Year\n
* Timeline for the Year\n
* Academic Update\n
* Super-curricular Update\n
* Reading and Academic Exploration Update`,
    'Initial Strategy Meeting (ISM)': `* Introductions\n
* Overview of UK application process\n
* Answer all initial questions\n
* Academics discussion\n
* Personal Development discussion\n
* Super-Curriculars discussion\n
* Subject Interest Development discussion\n
* Initial Majors, Careers, Schools discussion\n
* Next steps and homework setting`,
    'Pathfinder Meeting': `* Review Pathfinder and mark off achieved goals\n
* Establish 3-5 new goals\n
* Establish expectations around Pathfinder use during strategy\n
* Outline short-term (now to 3 months), mid-term (3-6 months), and long-term (6+ months) goals\n
* Review common/expected deadlines (eg. key EU deadlines for schools of interest)\n
* Review and send the respective NAY or AY timelines\n
* Other Check-in Items`,
    'AY: Strategy Meeting': '* N/A',
    'AY: App Mentoring Meeting': '* Essay writing guidance\n* Live feedback',
    'NAY: Meeting': '* N/A',
    'NAY: Mid Review Meeting': `* First Half of the Year Reflection\n
* Candidacy Assesment\n
* Other Check-ins`,
    'Confirmed Countries for Application Meeting': `* Final Intended Countries of Application\n
* Final University List\n
* Next Application Steps\n
* Application Portal Status Update\n
* Other Check-ins`,
    'Confirmed University Selection Meeting': `* Upcoming Timeline Outline\n
* Essay Status Update\n
* Provisional University List and Intended Degrees\n
* Candidacy Assessment\n
* Engagement Level\n
* Other Check-ins`,
    'AY: Timeline Alignment': '* N/A',
    'AY: Pre-Interview Meeting': `* Pre-Interview Strategy Guidance and Logistical Information\n
* Interview Tutoring and Utilisation Timeline\n
* Other Preparation`,
    'AY: Submission Meeting': `* Application Portal Review and Proof-Reading\n
* Essay Final Formatting\n
* Submission Timeline
  `,
    'AY: Post-All-Offers Meeting': `* Discussion of all Admission Outcomes\n
Final Choices\n
Other Crimson Opportunities
  `,
    'AY: Final Meeting Before Contract End': `* Final Questions and Guidance Needed\n
* Other Crimson Opportunities\n
* Good Luck and Stay in Touch!`,
    Other: '* N/A',
};
exports.EU_STRATEGIST_TEMPLATES = {
    'Year Start Meeting (YSM)': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Three Key Goals for the Year',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Timeline for the Year',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Academic Update',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Super-curricular Update',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Reading and Academic Exploration Update',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Initial Strategy Meeting (ISM)': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Introductions',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Overview of UK application process',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Answer all initial questions',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Academics discussion',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Personal Development discussion',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 6,
            type: 'p',
            children: [
                {
                    text: 'Super-Curriculars discussion',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 7,
            type: 'p',
            children: [
                {
                    text: 'Subject Interest Development discussion',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 8,
            type: 'p',
            children: [
                {
                    text: 'Initial Majors, Careers, Schools discussion',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 9,
            type: 'p',
            children: [
                {
                    text: 'Next steps and homework setting',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Pathfinder Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Review Pathfinder and mark off achieved goals',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Establish 3-5 new goals',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Establish expectations around Pathfinder use during strategy',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Outline short-term (now to 3 months), mid-term (3-6 months), and long-term (6+ months) goals',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Review common/expected deadlines (eg. key EU deadlines for schools of interest)',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 6,
            type: 'p',
            children: [
                {
                    text: 'Review and send the respective NAY or AY timelines',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 7,
            type: 'p',
            children: [
                {
                    text: 'Other Check-in Items',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Strategy Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: App Mentoring Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Essay writing guidance',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Live feedback',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'NAY: Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'NAY: Mid Review Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'First Half of the Year Reflection',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Candidacy Assesment',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Other Check-ins',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Confirmed Countries for Application Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Final Intended Countries of Application',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Final University List',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Next Application Steps',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Application Portal Status Update',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Other Check-ins',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Confirmed University Selection Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Upcoming Timeline Outline',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Essay Status Update',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Provisional University List and Intended Degrees',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Candidacy Assessment',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Engagement Level',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 6,
            type: 'p',
            children: [
                {
                    text: 'Other Check-ins',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Timeline Alignment': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Pre-Interview Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Pre-Interview Strategy Guidance and Logistical Information',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Interview Tutoring and Utilisation Timeline',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Other Preparation',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Submission Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Application Portal Review and Proof-Reading',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Essay Final Formatting',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Submission Timeline',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Post-All-Offers Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Discussion of all Admission Outcomes',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Final Choices',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Other Crimson Opportunities',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Final Meeting Before Contract End': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Final Questions and Guidance Needed',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Other Crimson Opportunities',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Good Luck and Stay in Touch!',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    Other: [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
};
//# sourceMappingURL=eu-strategist.js.map